<template>
  <button
    v-if="isSupported"
    class="button360 btn btn-outline-light"
    @click="toggle"
  >
    <img
      :src="icon"
      :title="$translate('modeherz::SingleItemPageClient.itemPageStart360View')"
      :alt="$translate('modeherz::SingleItemPageClient.itemPageStart360View')"
    >
  </button>
</template>

<script>
export default {
    name: 'Image360Button',
    props: {
        imagePath: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            isSupported: false
        }
    },
    mounted () {
        const that = this
        $.ajax(
            {
                url: this.imagePath + '?nocache=' + Math.random(),
                type: 'HEAD',
                error: function () {
                },
                success: function () {
                    that.isSupported = true
                    that.$emit('supported', true)
                }
            })
    },
    methods: {
        toggle () {
            $('.globalOverlay360').toggleClass('active')
            $('body').toggleClass('menu-is-visible')
        }
    }
}
</script>
